import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../core/services/auth.service';
import { AppRedirect } from '../../../../../core/utils/app-redirect';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@Component({
    selector: 'app-login',
    imports: [
        CommonModule,
        FormsModule,
        LoadingComponent,
        RouterModule,
        ToastrModule,
    ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent {

  loading=false
 
  constructor(
    private authService:AuthService,
    private lsService:LocalStorageService,
    private router: Router,
    private location: Location,
    private toastr: ToastrService
    ) { }

  ngOnInit(): void {
  }


  login(value:any){

    this.loading=true
    this.authService.login(value).subscribe((res:any)=>{

      this.lsService.set(GlobalName.tokenName,res.access_token)
      this.lsService.set(GlobalName.refreshTokenName,res.refresh_token)
      this.lsService.set(GlobalName.expireIn,res.expire_in);
      this.lsService.set(GlobalName.features,res.features);
     this.authService.me().subscribe((res:any)=>{
      this.loading=false
      this.lsService.set(GlobalName.userName,res.user);
      // Sans cette remise a zero, l'index de role du compte precedent
      // s'appliquait au nouveau et le menu pouvait rester vide.
      this.lsService.remove(GlobalName.currentRoleIndex);
      this.lsService.set(GlobalName.features,res.features);
     // this.router.navigate(['/admin/dashboard'])
     let url=AppRedirect.redirectLogin()
       this.router.navigate([url])

      this.toastr.success('Connexion réussie', 'Connexion');
     },
     (err:any)=>{
      this.loading=false
      this.toastr.error(err.error?.message, 'Connexion');

    })
     
    },
    (err:any)=>{
      this.loading=false
      this.toastr.error(err.error?.message, 'Connexion');

    });
  }
}
